"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const vasat_1 = require("vasat");
let EXTENSIONS = {
    "fa-file-code-o": ["html", "xml", "js", "coffee", "scala", "java", "cpp", "cs", "h", "m", "sh", "bat"],
    "fa-file-pdf-o": ["pdf"],
    "fa-file-word-o": ["doc", "docx"],
    "fa-file-audio-o": ["wav", "mp3", "ogg"],
    "fa-file-video-o": ["avi", "mpg", "mkv"],
    "fa-file-image-o": ["png", "gif", "jpg", "jpeg", "tiff"],
    "fa-file-text-o": ["txt"]
};
let ignoreKeys = ['parent', 'account', 'folder', 'transform', 'dataType', 'fid'];
/**
 * <p>Reference to Coordinate Reference System (CRS). More details on EPSG can be found <a href="https://www.puzzlr.org/epsg-codes-explained/">here</a>.</p>
 */
class EPSGCodes extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'EPSGCodes', args);
    }
}
exports.EPSGCodes = EPSGCodes;
class Widget extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'Widget', args);
    }
}
exports.Widget = Widget;
/**
 * <p>Defines the cost and limitations of the [[Account]].</p>
 */
class AccountPlan extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'AccountPlan', args);
    }
}
__decorate([
    vasat_1.AsToManyList(Widget),
    __metadata("design:type", vasat_1.ToManyList)
], AccountPlan.prototype, "availableWidgets", void 0);
exports.AccountPlan = AccountPlan;
/**
 * <p>Client object that is used to get the token</p>
 */
class Client extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'Client', args);
    }
}
exports.Client = Client;
/**
 * <p>Account class that is used for access control.</p>
 */
class Account extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'Account', args);
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
    /**
     * <p>Updates values of this object with parameter object values.</p>
     * @param a The object that you want to copy values of.
     */
    set(a) {
        if (a && a.permissions) {
            this.canWrite = a.permissions.find(p => p == 'api_update');
        }
        else {
            this.canWrite = false;
        }
        return super.set(a);
    }
    /**
     * <p>Parse this object to JSON format.</p>
     */
    toJSON() {
        let o = super.toJSON();
        // delete o.permissions
        delete o.canWrite;
        return o;
    }
    /**
     * <p>Checks if the account has the passed API type enabled.</p>
     * @param apiType
     */
    hasApiEnabled(apiType) {
        return this[apiType];
    }
    /**
     * <p>Enable/Disable API type</p>
     * @param apiType The API type you want to manipulate
     * @param enable True = Enable, False = Disable
     */
    enableDisableApi(apiType, enable) {
        this[apiType] = enable;
        return this.saveObservable();
    }
    accountPlanDetails(p = this.plan) {
        return this.vasat.api('/api/Account/' + this.id + '.plan?planId=' + p.id).pipe(operators_1.map(r => r));
    }
    previewPlan(sliders, p) {
        return this.vasat.api('/api/Account/' + this.id + '.plan?planId=' + p.id, 'post', sliders).pipe(operators_1.map(r => r));
    }
    updatePlan(sliders, p) {
        return this.vasat.api('/api/Account/' + this.id + '.plan?planId=' + p.id, 'put', sliders)
            .pipe(operators_1.flatMap(_ => this.fetchObservable()));
    }
    buyCredit(amount) {
        return this.vasat.api('/api/Account/' + this.id + '.plan/' + amount, 'post', {}).pipe(operators_1.flatMap(_ => this.fetchObservable()));
    }
}
__decorate([
    vasat_1.AsClass(AccountPlan),
    __metadata("design:type", AccountPlan)
], Account.prototype, "plan", void 0);
__decorate([
    vasat_1.AsClass(Account),
    __metadata("design:type", Account)
], Account.prototype, "parent", void 0);
__decorate([
    vasat_1.AsToManyList(vasat_1.AccessGroup),
    __metadata("design:type", vasat_1.ToManyList)
], Account.prototype, "accountGroups", void 0);
__decorate([
    vasat_1.AsToManyList(vasat_1.User),
    __metadata("design:type", vasat_1.ToManyList)
], Account.prototype, "invitedUsers", void 0);
exports.Account = Account;
/**
 * <p>AccountableModel is a model with an [[Account]], so that they are not accessible to the public.</p>
 */
class AccountableModel extends vasat_1.VasatModel {
    /**
     * <p>Retrieves this object</p>
     */
    fetchObservable() {
        var res = this.vasat.searchByObjectString(this.className()).equals('id', this.id).queryObservable().pipe(operators_1.map(res => this.set(res.items[0].toJSON())));
        return res;
    }
    /**
     * <p>Updates values of this object with parameter object values.</p>
     * @param a The object that you want to copy values of.
     */
    set(a) {
        if (a && a.permissions) {
            this.canWrite = a.permissions.find(p => p == 'api_update');
            this.canDelete = a.permissions.find(p => p == 'api_delete');
        }
        else {
            this.canWrite = false;
            this.canDelete = false;
        }
        return super.set(a);
    }
    /**
     * <p>Parse this object to JSON format.</p>
     */
    toJSON() {
        let o = super.toJSON();
        delete o.permissions;
        return o;
    }
}
__decorate([
    vasat_1.AsClass(Account),
    __metadata("design:type", Account)
], AccountableModel.prototype, "account", void 0);
exports.AccountableModel = AccountableModel;
class Tag extends AccountableModel {
    constructor(V, args) {
        super(V, 'Tag', args);
    }
}
exports.Tag = Tag;
/**
 * <p>ProcessorAPIs are very similar to [[TransformType]]s in that they describe the process that a [[Dataset]] will undergo, however ProcessorAPIs are third party processes that need to be set up.
 * These ProcessorAPIs are linked to the account.</p>
 */
class ProcessorAPI extends AccountableModel {
    constructor(V, args) {
        super(V, 'ProcessorAPI', args);
    }
}
exports.ProcessorAPI = ProcessorAPI;
/**
 * <p>Defines the type of transformation that a [[Dataset]] object will undergo.</p>
 */
class TransformType extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'TransformType', args);
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
}
__decorate([
    vasat_1.AsToManyList(ProcessorAPI),
    __metadata("design:type", vasat_1.ToManyList)
], TransformType.prototype, "apis", void 0);
__decorate([
    vasat_1.AsClass(TransformType),
    __metadata("design:type", TransformType)
], TransformType.prototype, "isSubTransform", void 0);
exports.TransformType = TransformType;
/**
 * <p>PlottableModel's are models/images that can be added to and displayed on the map.</p>
 */
class PlottableModel extends AccountableModel {
    /**
     * <p>Gets <a href="https://cesiumjs.org/Cesium/Build/Documentation/Rectangle.html">Cesium Rectangle</a> of this PlottableModel object.</p>
     */
    rectangle() {
        var Cesium = window['Cesium'];
        return Cesium.Rectangle.fromDegrees(this.llng, this.llat, this.ulng, this.ulat);
    }
    /**
     * <p>Gets <a href="https://cesiumjs.org/Cesium/Build/Documentation/Cartographic.html">Cesium Cartographic</a> from longitude and latitude specified in degrees</p>
     */
    cartographic() {
        var Cesium = window['Cesium'];
        return Cesium.Cartographic.fromDegrees(this.llng, this.llat, this.lheight ? this.lheight : this.uheight);
    }
    /**
     * <p>Creates a new <a href="https://cesiumjs.org/Cesium/Build/Documentation/Cartesian3.html">Cesium Cartesian3</a> instance from a Cartographic input.</p>
     */
    catresian() {
        var Cesium = window['Cesium'];
        return Cesium.Cartographic.toCartesian(this.cartographic());
    }
}
__decorate([
    vasat_1.AsClass(TransformType),
    __metadata("design:type", TransformType
    /**
     * <p>Gets <a href="https://cesiumjs.org/Cesium/Build/Documentation/Rectangle.html">Cesium Rectangle</a> of this PlottableModel object.</p>
     */
    )
], PlottableModel.prototype, "transformType", void 0);
exports.PlottableModel = PlottableModel;
/**
 * <p>DatasetType is used to associate the [[Dataset]] with the [[TransformType]]. When a file is uploaded, the type of file should be auto-detected to determine the necessary [[TransformType]]s to be added in the appropriate lists ([[adhocTransforms]]/[[autoApplyTransforms]]).</p>
 */
class DatasetType extends AccountableModel {
    constructor(V, args) {
        super(V, 'DatasetType', args);
    }
    set(a) {
        super.set(a);
        if (a._adhocTransforms) {
            this._adhocTransforms = a._adhocTransforms.map(id => this.vasat.findCached(TransformType, id));
        }
        return this;
    }
    /**
     * <p>Parse this object to JSON format.</p>
     */
    toJSON() {
        var v = super.toJSON();
        delete v._adhocTransforms;
        return v;
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
}
__decorate([
    vasat_1.AsToManyList(TransformType),
    __metadata("design:type", vasat_1.ToManyList)
], DatasetType.prototype, "adhocTransforms", void 0);
__decorate([
    vasat_1.AsToManyList(TransformType),
    __metadata("design:type", vasat_1.ToManyList)
], DatasetType.prototype, "autoApplyTransforms", void 0);
exports.DatasetType = DatasetType;
/**
 * <p>Folders contain the [[Dataset]]s or [[Transform]]s.</p>
 */
class Folder extends AccountableModel {
    constructor(V, args) {
        super(V, 'Folder', args);
        this.linkedFiles = new vasat_1.ToManyList(Dataset, this, 'linkedFiles');
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
    /**
     * <p>Updates values of this object with parameter object values.</p>
     * @param a The object that you want to copy values of.
     */
    set(a) {
        super.set(a);
        // cant get around declration order for @AsClass so resorting to manual
        if (a.forJobBatch)
            this.forJobBatch = this.vasat.findCached(JobBatch, a.forJobBatch.id) || a.forJobBatch;
        if (a.forScene)
            this.forScene = this.vasat.findCached(TransformGroup, a.forScene.id) || a.forScene;
        if (a.forProject)
            this.forProject = this.vasat.findCached(Project, a.forProject.id) || a.forProject;
        this.fid = "folder_" + this.id;
        return this;
    }
    /**
     * <p>Parse this object to JSON format.</p>
     */
    toJSON() {
        return super.toJSON();
    }
    getMeta() {
        let res = {};
        Object.keys(this).filter(k => !ignoreKeys.find(i => i == k)).forEach(k => res[k] = this[k]);
        return res;
    }
    /**
     * <p>Returns <a href="https://fontawesome.com/">Font Awesome</a> icon string identifier for folder.</p>
     * @param s
     */
    getIcon(s) {
        if (s.activeTeam.id != this.account.id) {
            return 'fa-users';
        }
        else if (!this.parent) {
            return 'fa-briefcase';
        }
        else {
            return 'fa-folder-o';
        }
    }
}
__decorate([
    vasat_1.AsClass(Folder),
    __metadata("design:type", Folder)
], Folder.prototype, "parent", void 0);
__decorate([
    vasat_1.AsClass(TransformType),
    __metadata("design:type", TransformType)
], Folder.prototype, "transform", void 0);
exports.Folder = Folder;
/**
 * <p>A file to be transformed depending on the [[TransformType]].</p>
 */
class Dataset extends AccountableModel {
    constructor(V, args, ncur) {
        super(V, 'Dataset', args);
        this.ncur = ncur;
        this.linkedInFolders = new vasat_1.ToManyList(Dataset, this, 'linkedInFolders');
    }
    /**
     * <p>Begins transform process depending on the [[TransformType]].</p>
     * @param tt [[TransformType]] you want to use
     * @param args
     */
    applyTransform(tt, args = {}, customAPI) {
        var extraURL = customAPI ? ('/' + customAPI.id) : '';
        return this.vasat.api('/api/Dataset/' + this.id + '/process/' + tt.uid + extraURL, 'post', args);
    }
    toJSON() {
        var v = super.toJSON();
        delete v.fails;
        delete v.transformIds;
        delete v.transforms;
        delete v.canPlot;
        return v;
    }
    quoteTransform(tt) {
        return this.vasat.api('/api/Dataset/' + this.id + '/process/' + tt.uid + '.quote');
    }
    uploadString(str, filename = 'data') {
        var url = this.vasat.config.host + '/api/Dataset/' + this.id + '.chunked/' + filename;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url + "?seq=0&offset=0&length=" + str.length + "&chunk=0&last=true");
        xhr.overrideMimeType("application/octet-stream");
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.vasat.token);
        xhr.send(str);
        var sub = new rxjs_1.Subject();
        xhr.onerror = (e) => {
            sub.error(e);
            sub.complete();
        };
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (!xhr.responseText || xhr.responseText == '') {
                    sub.error(new Error("Bad response"));
                }
                var res = JSON.parse(xhr.responseText);
                if (res.status && res.status < 400) {
                    sub.next(this);
                }
                else {
                    sub.error(new Error(res.message));
                }
                sub.complete();
            }
        };
        return sub.asObservable();
    }
}
__decorate([
    vasat_1.AsClass(Folder),
    __metadata("design:type", Folder)
], Dataset.prototype, "folder", void 0);
__decorate([
    vasat_1.AsClass(DatasetType),
    __metadata("design:type", DatasetType)
], Dataset.prototype, "dataType", void 0);
__decorate([
    vasat_1.AsClass(EPSGCodes),
    __metadata("design:type", EPSGCodes)
], Dataset.prototype, "crs", void 0);
exports.Dataset = Dataset;
/**
 * <p>Stores information related to plan and pay cycle etc.</p>
 */
class BillingSetup extends AccountableModel {
    constructor(V, args) {
        super(V, 'BillingSetup', args);
    }
}
exports.BillingSetup = BillingSetup;
/**
 * <p>Invoice</p>
 */
class Invoice extends AccountableModel {
    constructor(V, args) {
        super(V, 'Invoice', args);
    }
}
exports.Invoice = Invoice;
/**
 * <p>Individual items to be charged on invoices.</p>
 */
class InvoiceItem extends AccountableModel {
    constructor(V, args) {
        super(V, 'InvoiceItem', args);
    }
}
__decorate([
    vasat_1.AsClass(Invoice),
    __metadata("design:type", Invoice)
], InvoiceItem.prototype, "invoice", void 0);
__decorate([
    vasat_1.AsClass(BillingSetup),
    __metadata("design:type", BillingSetup)
], InvoiceItem.prototype, "plan", void 0);
exports.InvoiceItem = InvoiceItem;
/**
 * <p>A group of [[Dataset]]s.</p>
 */
class DatasetGroup extends AccountableModel {
    constructor(V, args) {
        super(V, 'DatasetGroup', args);
    }
    /**
     * <p>Appends the given [[Dataset]]s.</p>
     * @param ds An array of [[Dataset]]
     */
    addChildren(ds) {
        return rxjs_1.forkJoin(ds.map(d => this.children.addObserveable(d)));
    }
    /**
     * <p>Removes the given [[Dataset]].</p>
     * @param ds An array of [[Dataset]]
     */
    delChildren(ds) {
        return rxjs_1.forkJoin(ds.map(d => this.children.removeObservable(d)));
    }
    /**
     * <p>Returns <a href=" link to vasatsearchresults ">Vasat Search Results</a>.</p>
     */
    getChildren() {
        return this.children.queryObservable();
    }
}
__decorate([
    vasat_1.AsToManyList(Dataset),
    __metadata("design:type", vasat_1.ToManyList)
], DatasetGroup.prototype, "children", void 0);
__decorate([
    vasat_1.AsClass(DatasetGroup),
    __metadata("design:type", DatasetGroup)
], DatasetGroup.prototype, "parent", void 0);
exports.DatasetGroup = DatasetGroup;
/**
 * <p>Transform objects are plottable objects. Transforms have several different [[TransformType]]s. The different types of transforms are: kml, laz, photo-dzi, terrain tiles*, three-d-tiles*, tms
 * <footer>Note: The types denoted by an asterix(*) are 3D models that are currently only supported by our Cesium helper class ([[FourdCesiumHelper]]).</footer></p>
 */
class Transform extends PlottableModel {
    constructor(V, args, ncur) {
        super(V, 'Transform', args);
        this.ncur = ncur;
    }
    /**
     * <p>Updates values of this object with parameter object values.</p>
     * @param a The object that you want to copy values of.
     */
    set(a) {
        let v = super.set(a);
        if (!this.ncur && this.outputs) {
            this.outputs = this.outputs.map(c => new Dataset(this.vasat, c, true));
        }
        return v;
    }
    /**
     * <p>Gets the [[Annotation]]s for this Transform object.</p>
     */
    getAnnotations() {
        return this.vasat.searchByObject(Annotation)
            .equals('transform', this.id)
            .sortBy('name')
            .limit(201)
            .queryObservable()
            .pipe(operators_1.map(res => res.items));
    }
    toJSON() {
        var a = super.toJSON();
        delete a.__properties;
        delete a.__detected;
        delete a.issues;
        return a;
    }
}
__decorate([
    vasat_1.AsClass(Dataset),
    __metadata("design:type", Dataset)
], Transform.prototype, "input", void 0);
__decorate([
    vasat_1.AsToManyList(Tag),
    __metadata("design:type", vasat_1.ToManyList)
], Transform.prototype, "tags", void 0);
exports.Transform = Transform;
/**
 * <p>Project is a collection of data, which can be shared with other [[User]]s or [[Client]]s.</p>
 */
class Project extends PlottableModel {
    constructor(V, args) {
        super(V, 'Project', args);
    }
    get projectFolder() {
        return this.vasat.searchByObject(Folder).equals('forProject', this.id).useCache(true).queryObservable().pipe(operators_1.map(r => {
            if (r.items.length != 1)
                throw new Error("Folders for project [" + this.id + '] returned ' + r.items.length);
            return r.items[0];
        }));
    }
    /**
     * <p>Create a new [[Folder]].</p>
     */
    addTransformsFromFolder(f, filterType) {
        var v = new vasat_1.VasatAPICall();
        var typeS = '';
        if (filterType && filterType.length) {
            filterType.forEach(f => typeS += ',' + f.id);
            typeS = typeS.substring(1);
        }
        return v.apiObservable(this.vasat, 'put', '/api/Project/' + this.id + '/addFolder/' + f.id + '/' + (filterType ? typeS : 'all'), {});
    }
    /**
     * <p>Clear all Transforms.</p>
     */
    removeAllTransforms(filterType) {
        var typeS = '';
        if (filterType && filterType.length) {
            filterType.forEach(f => typeS += ',' + f.id);
            typeS = typeS.substring(1);
        }
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'delete', '/api/Project/' + this.id + '/rmAll/' + (filterType ? typeS : 'all'));
    }
    /**
     * <p>Retrieves the list of [[TransformGroup]]s associated with this Project object.</p>
     */
    groupList() {
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'get', '/api/Project/' + this.id + '?groups=true').pipe(operators_1.map(res => {
            var aa = res.grouped;
            return aa.map(a => {
                var tg = (this.vasat.findCached(TransformGroup, a.id) || new TransformGroup(this.vasat));
                var tts = a.transforms;
                tg._cachedTransforms = tts.map(t => (this.vasat.findCached(Transform, t.id) || new Transform(this.vasat)).set(t));
                delete a.transforms;
                tg.set(a);
                return tg;
            });
        }), operators_1.tap(res => this.vasat.registerCacheClass(TransformGroup, res)));
    }
}
__decorate([
    vasat_1.AsToManyList(Transform),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "transforms", void 0);
__decorate([
    vasat_1.AsToManyList(Transform),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "photos", void 0);
__decorate([
    vasat_1.AsToManyList(Dataset),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "datasets", void 0);
__decorate([
    vasat_1.AsToManyList(Folder),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "folders", void 0);
__decorate([
    vasat_1.AsToManyList(vasat_1.User),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "shareUsers", void 0);
__decorate([
    vasat_1.AsToManyList(Client),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "shareClients", void 0);
__decorate([
    vasat_1.AsToManyList(Tag),
    __metadata("design:type", vasat_1.ToManyList)
], Project.prototype, "tags", void 0);
exports.Project = Project;
/**
 * <p>A group of [[Transform]] objects.</p>
 */
class TransformGroup extends AccountableModel {
    constructor(V, args) {
        super(V, 'TransformGroup', args);
        this.layerProps = {};
    }
    get sceneFolder() {
        return this.vasat.searchByObject(Folder).equals('forScene', this.id).useCache(true).queryObservable().pipe(operators_1.map(r => {
            if (r.items.length != 1)
                throw new Error("Folders for scene [" + this.id + '] returned ' + r.items.length);
            return r.items[0];
        }));
    }
    /**
     * <p>Adds all the images from the specified [[Folder]] to this TransformGroup. Action will also add the same photos to the [[Project]]s photos and any Photogrammetry [[Job]].</p>
     */
    addImagesFromFolder(f) {
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'put', '/api/TransformGroup/' + this.id + '/addFolder/' + f.id + '?access_token=' + this.vasat.token);
    }
    /**
     * <p>Remove any images associated with this TransformGroup object.</p>
     */
    removeAllImages() {
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'delete', '/api/TransformGroup/' + this.id + '/rmAllPhotos?access_token=' + this.vasat.token);
    }
    /**
     * <p>Add [[Transform]](s) to this TransformGroup object.</p>
     * @param ds Objects to add
     */
    addChildren(ds) {
        return rxjs_1.forkJoin(ds.map(d => this.children.addObserveable(d)));
    }
    /**
     * <p>Remove [[Transform]](s) to this TransformGroup object.</p>
     * @param ds Objects to remove
     */
    delChildren(ds) {
        return rxjs_1.forkJoin(ds.map(d => this.children.removeObservable(d)));
    }
    addFromFiles(ds) {
        return this.vasat.api('/api/TransformGroup/' + this.id + '/addDatasets', 'put', { "files": ds.map(d => d.id) });
    }
    /**
     * <p>Retrieves the [[Transform]]s associated with this TransformGroup object.</p>
     */
    getChildren() {
        return this.children.queryObservable();
    }
    /**
     * <p>Gets the Shapes at a given point of this TransformGroup object.</p>
     * @param latDeg Latitude in degrees
     * @param lngDeg Longitude in degrees
     * @param height
     */
    queryShapesAtPoint(latDeg, lngDeg, height) {
        return this.vasat.api('/api/TransformGroup/' + this.id + '.shape?lat=' + latDeg + '&lng=' + lngDeg + '&height' + (height || 0));
    }
    /**
     * <p>Parse this object to JSON format.</p>
     */
    toJSON() {
        var a = super.toJSON();
        delete a._cachedTransforms;
        delete a._photo_count;
        return a;
    }
    isShowing(t) {
        return this.layerProps['toggle_' + t.id];
    }
    setShowing(t, showing) {
        this.layerProps['toggle_' + t.id] = showing;
    }
    getAlpha(t) {
        return this.layerProps['alpha_' + t.id];
    }
    setAlpha(t, opacity) {
        this.layerProps['alpha_' + t.id] = opacity;
    }
    getSceneFolder() {
        return this.vasat.searchByObject(Folder)
            .equals('forScene', this.id)
            .useCache(true)
            .queryObservable()
            .pipe(operators_1.map(r => r.items[0]));
    }
}
__decorate([
    vasat_1.AsToManyList(Transform),
    __metadata("design:type", vasat_1.ToManyList)
], TransformGroup.prototype, "children", void 0);
__decorate([
    vasat_1.AsToManyList(Transform),
    __metadata("design:type", vasat_1.ToManyList)
], TransformGroup.prototype, "photos", void 0);
__decorate([
    vasat_1.AsClass(TransformGroup),
    __metadata("design:type", TransformGroup)
], TransformGroup.prototype, "parent", void 0);
__decorate([
    vasat_1.AsClass(Project),
    __metadata("design:type", Project
    /**
     * stop using this
     * @depricated
     */
    )
], TransformGroup.prototype, "project", void 0);
__decorate([
    vasat_1.AsClass(Folder),
    __metadata("design:type", Folder)
], TransformGroup.prototype, "folder", void 0);
__decorate([
    vasat_1.AsToManyList(Tag),
    __metadata("design:type", vasat_1.ToManyList)
], TransformGroup.prototype, "tags", void 0);
exports.TransformGroup = TransformGroup;
/**
 * <p>Describes the different [[TransformType]]s that the [[Job]] will undertake.</p>
 */
class JobType extends vasat_1.VasatModel {
    constructor(V, args) {
        super(V, 'JobType', args);
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
}
__decorate([
    vasat_1.AsClass(TransformType),
    __metadata("design:type", TransformType)
], JobType.prototype, "baseTransform", void 0);
__decorate([
    vasat_1.AsToManyList(TransformType),
    __metadata("design:type", vasat_1.ToManyList)
], JobType.prototype, "subTransforms", void 0);
exports.JobType = JobType;
/**
 * <p>Job outlines the [[Dataset]](s) that will be transformed depending on the [[JobType]]/[[TransformType]].</p>
 */
class Job extends AccountableModel {
    constructor(V, args) {
        super(V, 'Job', args);
    }
    /**
     * <p>Queries for the associated [[JobBatch]] and reurns a <a href=" linkToVasat ">VasatSearchQuery</a> containging the results.</p>
     */
    batches() {
        return this.vasat.searchByObject(JobBatch).equals('parent', this.id).equals('active', true);
    }
    /**
     * <p>Refresh the status of processing.</p>
     */
    refreshStatus() {
        return this.vasat.api(this.vasat.pathPrefix + '/Job/process/' + this.id, 'get');
    }
    /**
     * <p>Starts the processing.</p>
     * @param t
     * @param args
     */
    startTransform(t, args, customAPI) {
        var extraURL = customAPI ? ('/' + customAPI.id) : '';
        args = args || {};
        return this.vasat.api(this.vasat.pathPrefix + '/Job/process/' + this.id + '/' + t.uid + extraURL, 'post', args);
    }
    /**
     * <p>Retrieve estimated cost of Job.</p>
     */
    getEstimatedPrice(t) {
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'get', '/api/Job/' + this.id + '/checkout?access_token=' + this.vasat.token);
    }
    /**
     * <p>Start checkout process.</p>
     * @param noonce
     */
    makePayment(noonce) {
        var v = new vasat_1.VasatAPICall();
        return v.apiObservable(this.vasat, 'post', '/api/Job/' + this.id + '/checkout?access_token=' + this.vasat.token, { noonce: noonce });
    }
    quoteTransform(tt) {
        return this.vasat.api('/api/Job/' + this.id + '/process/' + tt.uid + '.quote');
    }
}
__decorate([
    vasat_1.AsClass(JobType),
    __metadata("design:type", JobType)
], Job.prototype, "jobType", void 0);
__decorate([
    vasat_1.AsClass(TransformGroup),
    __metadata("design:type", TransformGroup)
], Job.prototype, "scene", void 0);
__decorate([
    vasat_1.AsClass(ProcessorAPI),
    __metadata("design:type", ProcessorAPI)
], Job.prototype, "processorAPI", void 0);
__decorate([
    vasat_1.AsToManyList(Dataset),
    __metadata("design:type", vasat_1.ToManyList)
], Job.prototype, "inputDatasets", void 0);
__decorate([
    vasat_1.AsToManyList(Folder),
    __metadata("design:type", vasat_1.ToManyList)
], Job.prototype, "inputFolders", void 0);
exports.Job = Job;
/**
 * <p>A JobBatch is a child of a [[Job]] that is undergoing a process or has already undergone transformation. A key difference to a [[Job]] is that it only has one [[TransformType]].</p>
 * <footer>Note that you will have to create a new [[Folder]] containing the outputs.</footer>
 */
class JobBatch extends AccountableModel {
    constructor(V, args) {
        super(V, 'JobBatch', args);
    }
    getBatchFolder() {
        return this.vasat.searchByObject(Folder)
            .equals('forJobBatch', this.id)
            .useCache(true)
            .queryObservable()
            .pipe(operators_1.map(r => r.items[0]));
    }
}
__decorate([
    vasat_1.AsClass(Job),
    __metadata("design:type", Job)
], JobBatch.prototype, "parent", void 0);
__decorate([
    vasat_1.AsClass(TransformType),
    __metadata("design:type", TransformType)
], JobBatch.prototype, "transformType", void 0);
__decorate([
    vasat_1.AsToManyList(Dataset),
    __metadata("design:type", vasat_1.ToManyList)
], JobBatch.prototype, "outputs", void 0);
exports.JobBatch = JobBatch;
/**
 * <p>Annotations are plottable objects. Usually pins/markers/measurements.</p>
 */
class Annotation extends PlottableModel {
    constructor(V, args) {
        super(V, 'Annotation', args);
        this.style = {};
    }
}
__decorate([
    vasat_1.AsClass(Transform),
    __metadata("design:type", Transform)
], Annotation.prototype, "transform", void 0);
__decorate([
    vasat_1.AsClass(Project),
    __metadata("design:type", Project)
], Annotation.prototype, "project", void 0);
__decorate([
    vasat_1.AsToManyList(Tag),
    __metadata("design:type", vasat_1.ToManyList)
], Annotation.prototype, "tags", void 0);
exports.Annotation = Annotation;
class InviteRequest extends AccountableModel {
    constructor(V, args) {
        super(V, 'InviteRequest', args);
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
}
__decorate([
    vasat_1.AsClass(Account),
    __metadata("design:type", Account)
], InviteRequest.prototype, "targetAccount", void 0);
__decorate([
    vasat_1.AsClass(Project),
    __metadata("design:type", Project)
], InviteRequest.prototype, "targetProject", void 0);
__decorate([
    vasat_1.AsClass(vasat_1.User),
    __metadata("design:type", vasat_1.User)
], InviteRequest.prototype, "createdBy", void 0);
__decorate([
    vasat_1.AsClass(vasat_1.User),
    __metadata("design:type", vasat_1.User)
], InviteRequest.prototype, "BindUser", void 0);
exports.InviteRequest = InviteRequest;
class Message extends AccountableModel {
    constructor(V, args) {
        super(V, 'Message', args);
    }
    GUID() {
        return this.uid;
    }
    GUID_FIELD_NAME() {
        return 'uid';
    }
}
__decorate([
    vasat_1.AsClass(Message),
    __metadata("design:type", Message)
], Message.prototype, "thread", void 0);
__decorate([
    vasat_1.AsClass(InviteRequest),
    __metadata("design:type", InviteRequest)
], Message.prototype, "invite", void 0);
__decorate([
    vasat_1.AsClass(JobBatch),
    __metadata("design:type", JobBatch)
], Message.prototype, "jobBatch", void 0);
__decorate([
    vasat_1.AsClass(Transform),
    __metadata("design:type", Transform)
], Message.prototype, "transform", void 0);
__decorate([
    vasat_1.AsClass(vasat_1.User),
    __metadata("design:type", vasat_1.User)
], Message.prototype, "user", void 0);
exports.Message = Message;
